import axios from "axios"; // 要导入安装的包，则直接填写包名即可。不需要使用路径
import querystring from "querystring";
axios.defaults.withCredentials = true;

const errorHandle = (status,info) => {
    switch (status) {
        case 400:
            console.log("语义有误");
            break;
        case 401:
            console.log("服务器认证失败");
            break;
        case 403:
            console.log("服务器拒绝访问");
            break;
        case 404:
            console.log("地址错误");
            break;
        case 500:
            console.log("服务器遇到意外");
            break;
        case 502:
            console.log("服务器无响应");
            break;
        default:
            console.log(info)
            break;
    }
}
// const BsaeURL = 'http://192.168.8.107:8000/'
// const BsaeURL = 'http://192.168.43.195:8000/'

// const BsaeURL = 'http://127.0.0.1:8000/'
const BsaeURL = '/api/'

// 实例化
const httptool = axios.create({
      // baseURL: 'http://127.0.0.1:8000/', // 请求的公共路径,一般填写服务端的api地址
      // baseURL: 'http://192.168.8.159:8000/', // 请求的公共路径,一般填写服务端的api地址
      baseURL: BsaeURL, // 请求的公共路径,一般填写服务端的api地址
      // baseURL: 'http://wthrcdn.etouch.cn/', // 请求的公共路径,一般填写服务端的api地址
      timeout: 10001,                           // 最大请求超时时间，请求超过这个时间则报错
      headers: {'content-type': 'foobar'}   // 预定义请求头，一般工作中这里填写隐藏了客户端身份的字段
      // headers: {
      //     'content-type': 'multipart/form-data',
      // }
});

// 拦截器
// 添加一个请求拦截器
httptool.interceptors.request.use((config)=>{
    // if(config.method === "post") {
    //     config.data = querystring.stringify(config.data)
    // }
    console.log("http请求之前");
    return config;
  }, (error)=>{
    console.log("http请求错误");
    return Promise.reject(error);
  });

// 添加一个响应拦截器
httptool.interceptors.response.use((response)=>{
    // console.log("服务端响应数据成功以后，返回结果给客户端的第一时间，执行then之前");
    // return response;
    console.log(response)
    return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
}, (error)=>{
    // console.log("服务端响应错误内容的时候...")
    // return Promise.reject(error);
    console.log(error)
    const { response } = error
    errorHandle(response.status, response.info)
});

export { BsaeURL };
export default httptool;
